// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* hide indicator for input number */\n\n/* Chrome, Safari, Edge, Opera */\ninput[data-v-02106df9]::-webkit-outer-spin-button,\ninput[data-v-02106df9]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"][data-v-02106df9] {\n  -moz-appearance: textfield;\n}\n", ""]);
// Exports
module.exports = exports;
